import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-40 w-full border-b border-gold/30 bg-night-deep text-cream" data-id="element-1" data-mp="omwq1i5aglap">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2 sm:px-5 sm:py-2.5" data-id="element-2" data-mp="js0mplulqbia">
        <p className="text-[11px] font-medium leading-snug sm:text-[13px]" data-id="element-3" data-mp="et63wjwmwmy6">
          <span className="font-semibold uppercase tracking-[0.1em] text-gold" data-id="element-4" data-mp="9x8oqgx3xmmz">Promo</span>{' '}
          <span className="sm:hidden" data-id="element-5" data-mp="5t0xod36full">6 volumes + 6 free bonuses — only $27</span>
          <span className="hidden sm:inline" data-id="element-6" data-mp="w0qtzyi6ntf">
            6-volume bundle + 6 free bonuses for 60% off — only $27. Offer ends tonight.
          </span>
        </p>
        <div className="flex shrink-0 items-center gap-2" data-id="element-7" data-mp="1v90coath8e95">
          <span className="hidden text-[11px] font-semibold uppercase tracking-[0.14em] text-cream-muted sm:inline" data-id="element-8" data-mp="1v8h3bihw6y6q">
            Ends in
          </span>
          <span className="text-[11px] font-semibold tabular-nums text-gold sm:text-[13px]" data-id="element-9" data-mp="680e70y1hub8">
            {hours}:{minutes}:{seconds}
          </span>
        </div>
      </div>
    </div>;
}